import * as constants from "../constants.js";
import notifications from "../notifications";


export default {
    OnSuccess(description) {
        notifications.Success("Serviços", description);
    },

    OnWarning(resp, description) {
        notifications.Warning("Serviços", description);
        console.log(resp);
    },

    OnError(resp, description) {
        notifications.Error("Serviços", description);
        console.log(resp);
    },

    OnUnauthorized(){
        window.location = "/";
    },
    
    GetProcurementService: async function () {
        let reqUri = `${constants.API_ENDPOINT_SERVICES}/procurement`;
        let result = await fetch(reqUri, {
                            method: constants.HTTP_METHOD_GET 
                        })
                        .then(resp => {
                            if (!resp.ok) {
                                if (resp.status >= 500) {
                                    this.OnError(resp, "Ocorreu uma anomalia ao carregar o Serviço de Propostas");
                                    return null;
                                } else if(resp.status == 401){
                                    this.OnUnauthorized();
                                    return null;
                                } else if (resp.status >= 400){
                                    return null;
                                }
                            }

                            if (resp.status == 204) 
                                return null;

                            return resp.json();
                        });

        return result;
    },

    GetHighlightService: async function () {
        let reqUri = `${constants.API_ENDPOINT_SERVICES}/highlight`;
        let result = await fetch(reqUri, {
                            method: constants.HTTP_METHOD_GET 
                        })
                        .then(resp => {
                            if (!resp.ok) {
                                if (resp.status >= 500) {
                                    this.OnError(resp, "Ocorreu uma anomalia ao carregar o Serviço de Destaques");
                                    return null;
                                } else if(resp.status == 401){
                                    this.OnUnauthorized();
                                    return null;
                                } else if (resp.status >= 400){
                                    return null;
                                }
                            }

                            if (resp.status == 204) 
                                return null;
                                
                            return resp.json();
                        });

        return result;
    },
    GetCarMatchUsedService: async function () {
        let reqUri = `${constants.API_ENDPOINT_SERVICES}/carmatchused`;
        let result = await fetch(reqUri, {
                            method: constants.HTTP_METHOD_GET 
                        })
                        .then(resp => {
                            if (!resp.ok) {
                                if (resp.status >= 500) {
                                    this.OnError(resp, "Ocorreu uma anomalia ao carregar o Serviço de CarMatch");
                                    return null;
                                } else if(resp.status == 401){
                                    this.OnUnauthorized();
                                    return null;
                                } else if (resp.status >= 400){
                                    return null;
                                }
                            }

                            if (resp.status == 204) 
                                return null;

                            return resp.json();
                        });

        return result;
    },
}
